/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EmailSignatureResponse } from './emailSignatureResponse';

/**
 * Paginated envelope for ``GET /signatures/email``.
 */
export interface EmailSignatureListResponse {
  items: EmailSignatureResponse[];
  total: number;
  page: number;
  page_size: number;
  has_more: boolean;
}
